import { render } from "./ImgCodeVersion7_1.vue?vue&type=template&id=6cb962d6&scoped=true&ts=true"
import script from "./ImgCodeVersion7_1.vue?vue&type=script&lang=ts"
export * from "./ImgCodeVersion7_1.vue?vue&type=script&lang=ts"

import "./ImgCodeVersion7_1.vue?vue&type=style&index=0&id=6cb962d6&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb962d6"]])

export default __exports__